import { omit } from 'utilium';
/**
 * Standard POSIX error codes.
 * @see https://en.wikipedia.org/wiki/Errno.h
 */
export var Errno;
(function (Errno) {
    /** Operation not permitted */
    Errno[Errno["EPERM"] = 1] = "EPERM";
    /** No such file or directory */
    Errno[Errno["ENOENT"] = 2] = "ENOENT";
    /** No such process */
    Errno[Errno["ESRCH"] = 3] = "ESRCH";
    /** Interrupted system call */
    Errno[Errno["EINTR"] = 4] = "EINTR";
    /** Input/output error */
    Errno[Errno["EIO"] = 5] = "EIO";
    /** No such device or address */
    Errno[Errno["ENXIO"] = 6] = "ENXIO";
    /** Argument list too long */
    Errno[Errno["E2BIG"] = 7] = "E2BIG";
    /** Exec format error */
    Errno[Errno["ENOEXEC"] = 8] = "ENOEXEC";
    /** Bad file descriptor */
    Errno[Errno["EBADF"] = 9] = "EBADF";
    /** No child processes */
    Errno[Errno["ECHILD"] = 10] = "ECHILD";
    /** Resource temporarily unavailable */
    Errno[Errno["EAGAIN"] = 11] = "EAGAIN";
    /** Out of memory */
    Errno[Errno["ENOMEM"] = 12] = "ENOMEM";
    /** Permission denied */
    Errno[Errno["EACCES"] = 13] = "EACCES";
    /** Bad address */
    Errno[Errno["EFAULT"] = 14] = "EFAULT";
    /** Block device required */
    Errno[Errno["ENOTBLK"] = 15] = "ENOTBLK";
    /** Resource busy or locked */
    Errno[Errno["EBUSY"] = 16] = "EBUSY";
    /** File exists */
    Errno[Errno["EEXIST"] = 17] = "EEXIST";
    /** Invalid cross-device link */
    Errno[Errno["EXDEV"] = 18] = "EXDEV";
    /** No such device */
    Errno[Errno["ENODEV"] = 19] = "ENODEV";
    /** File is not a directory */
    Errno[Errno["ENOTDIR"] = 20] = "ENOTDIR";
    /** File is a directory */
    Errno[Errno["EISDIR"] = 21] = "EISDIR";
    /** Invalid argument */
    Errno[Errno["EINVAL"] = 22] = "EINVAL";
    /** Too many open files in system */
    Errno[Errno["ENFILE"] = 23] = "ENFILE";
    /** Too many open files */
    Errno[Errno["EMFILE"] = 24] = "EMFILE";
    /** Text file busy */
    Errno[Errno["ETXTBSY"] = 26] = "ETXTBSY";
    /** File is too big */
    Errno[Errno["EFBIG"] = 27] = "EFBIG";
    /** No space left on disk */
    Errno[Errno["ENOSPC"] = 28] = "ENOSPC";
    /** Illegal seek */
    Errno[Errno["ESPIPE"] = 29] = "ESPIPE";
    /** Cannot modify a read-only file system */
    Errno[Errno["EROFS"] = 30] = "EROFS";
    /** Too many links */
    Errno[Errno["EMLINK"] = 31] = "EMLINK";
    /** Broken pipe */
    Errno[Errno["EPIPE"] = 32] = "EPIPE";
    /** Numerical argument out of domain */
    Errno[Errno["EDOM"] = 33] = "EDOM";
    /** Numerical result out of range */
    Errno[Errno["ERANGE"] = 34] = "ERANGE";
    /** Resource deadlock would occur */
    Errno[Errno["EDEADLK"] = 35] = "EDEADLK";
    /** File name too long */
    Errno[Errno["ENAMETOOLONG"] = 36] = "ENAMETOOLONG";
    /** No locks available */
    Errno[Errno["ENOLCK"] = 37] = "ENOLCK";
    /** Function not implemented */
    Errno[Errno["ENOSYS"] = 38] = "ENOSYS";
    /** Directory is not empty */
    Errno[Errno["ENOTEMPTY"] = 39] = "ENOTEMPTY";
    /** Too many levels of symbolic links */
    Errno[Errno["ELOOP"] = 40] = "ELOOP";
    /** No message of desired type */
    Errno[Errno["ENOMSG"] = 42] = "ENOMSG";
    /** Identifier removed */
    Errno[Errno["EIDRM"] = 43] = "EIDRM";
    /** Channel number out of range */
    Errno[Errno["ECHRNG"] = 44] = "ECHRNG";
    /** Level 2 not synchronized */
    Errno[Errno["EL2NSYNC"] = 45] = "EL2NSYNC";
    /** Level 3 halted */
    Errno[Errno["EL3HLT"] = 46] = "EL3HLT";
    /** Level 3 reset */
    Errno[Errno["EL3RST"] = 47] = "EL3RST";
    /** Link number out of range */
    Errno[Errno["ENRNG"] = 48] = "ENRNG";
    /** Protocol driver not attached */
    Errno[Errno["EUNATCH"] = 49] = "EUNATCH";
    /** No CSI structure available */
    Errno[Errno["ECSI"] = 50] = "ECSI";
    /** Level 2 halted */
    Errno[Errno["EL2HLT"] = 51] = "EL2HLT";
    /** Invalid exchange */
    Errno[Errno["EBADE"] = 52] = "EBADE";
    /** Invalid request descriptor */
    Errno[Errno["EBADR"] = 53] = "EBADR";
    /** Exchange full */
    Errno[Errno["EXFULL"] = 54] = "EXFULL";
    /** No anode */
    Errno[Errno["ENOANO"] = 55] = "ENOANO";
    /** Invalid request code */
    Errno[Errno["EBADRQC"] = 56] = "EBADRQC";
    /** Invalid slot */
    Errno[Errno["EBADSLT"] = 57] = "EBADSLT";
    /** Bad font file format */
    Errno[Errno["EBFONT"] = 59] = "EBFONT";
    /** Device not a stream */
    Errno[Errno["ENOSTR"] = 60] = "ENOSTR";
    /** No data available */
    Errno[Errno["ENODATA"] = 61] = "ENODATA";
    /** Timer expired */
    Errno[Errno["ETIME"] = 62] = "ETIME";
    /** Out of streams resources */
    Errno[Errno["ENOSR"] = 63] = "ENOSR";
    /** Machine is not on the network */
    Errno[Errno["ENONET"] = 64] = "ENONET";
    /** Package not installed */
    Errno[Errno["ENOPKG"] = 65] = "ENOPKG";
    /** Object is remote */
    Errno[Errno["EREMOTE"] = 66] = "EREMOTE";
    /** Link has been severed */
    Errno[Errno["ENOLINK"] = 67] = "ENOLINK";
    /** Advertise error */
    Errno[Errno["EADV"] = 68] = "EADV";
    /** Srmount error */
    Errno[Errno["ESRMNT"] = 69] = "ESRMNT";
    /** Communication error on send */
    Errno[Errno["ECOMM"] = 70] = "ECOMM";
    /** Protocol error */
    Errno[Errno["EPROTO"] = 71] = "EPROTO";
    /** Multihop attempted */
    Errno[Errno["EMULTIHOP"] = 72] = "EMULTIHOP";
    /** RFS specific error */
    Errno[Errno["EDOTDOT"] = 73] = "EDOTDOT";
    /** Bad message */
    Errno[Errno["EBADMSG"] = 74] = "EBADMSG";
    /** Value too large for defined data type */
    Errno[Errno["EOVERFLOW"] = 75] = "EOVERFLOW";
    /** Name not unique on network */
    Errno[Errno["ENOTUNIQ"] = 76] = "ENOTUNIQ";
    /** File descriptor in bad state */
    Errno[Errno["EBADFD"] = 77] = "EBADFD";
    /** Remote address changed */
    Errno[Errno["EREMCHG"] = 78] = "EREMCHG";
    /** Can not access a needed shared library */
    Errno[Errno["ELIBACC"] = 79] = "ELIBACC";
    /** Accessing a corrupted shared library */
    Errno[Errno["ELIBBAD"] = 80] = "ELIBBAD";
    /** .lib section in a.out corrupted */
    Errno[Errno["ELIBSCN"] = 81] = "ELIBSCN";
    /** Attempting to link in too many shared libraries */
    Errno[Errno["ELIBMAX"] = 82] = "ELIBMAX";
    /** Cannot exec a shared library directly */
    Errno[Errno["ELIBEXEC"] = 83] = "ELIBEXEC";
    /** Invalid or incomplete multibyte or wide character */
    Errno[Errno["EILSEQ"] = 84] = "EILSEQ";
    /** Interrupted system call should be restarted */
    Errno[Errno["ERESTART"] = 85] = "ERESTART";
    /** Streams pipe error */
    Errno[Errno["ESTRPIPE"] = 86] = "ESTRPIPE";
    /** Too many users */
    Errno[Errno["EUSERS"] = 87] = "EUSERS";
    /** Socket operation on non-socket */
    Errno[Errno["ENOTSOCK"] = 88] = "ENOTSOCK";
    /** Destination address required */
    Errno[Errno["EDESTADDRREQ"] = 89] = "EDESTADDRREQ";
    /** Message too long */
    Errno[Errno["EMSGSIZE"] = 90] = "EMSGSIZE";
    /** Protocol wrong type for socket */
    Errno[Errno["EPROTOTYPE"] = 91] = "EPROTOTYPE";
    /** Protocol not available */
    Errno[Errno["ENOPROTOOPT"] = 92] = "ENOPROTOOPT";
    /** Protocol not supported */
    Errno[Errno["EPROTONOSUPPORT"] = 93] = "EPROTONOSUPPORT";
    /** Socket type not supported */
    Errno[Errno["ESOCKTNOSUPPORT"] = 94] = "ESOCKTNOSUPPORT";
    /** Operation is not supported */
    Errno[Errno["ENOTSUP"] = 95] = "ENOTSUP";
    /** Protocol family not supported */
    Errno[Errno["EPFNOSUPPORT"] = 96] = "EPFNOSUPPORT";
    /** Address family not supported by protocol */
    Errno[Errno["EAFNOSUPPORT"] = 97] = "EAFNOSUPPORT";
    /** Address already in use */
    Errno[Errno["EADDRINUSE"] = 98] = "EADDRINUSE";
    /** Cannot assign requested address */
    Errno[Errno["EADDRNOTAVAIL"] = 99] = "EADDRNOTAVAIL";
    /** Network is down */
    Errno[Errno["ENETDOWN"] = 100] = "ENETDOWN";
    /** Network is unreachable */
    Errno[Errno["ENETUNREACH"] = 101] = "ENETUNREACH";
    /** Network dropped connection on reset */
    Errno[Errno["ENETRESET"] = 102] = "ENETRESET";
    /** Software caused connection abort */
    Errno[Errno["ECONNABORTED"] = 103] = "ECONNABORTED";
    /** Connection reset by peer */
    Errno[Errno["ECONNRESET"] = 104] = "ECONNRESET";
    /** No buffer space available */
    Errno[Errno["ENOBUFS"] = 105] = "ENOBUFS";
    /** Transport endpoint is already connected */
    Errno[Errno["EISCONN"] = 106] = "EISCONN";
    /** Transport endpoint is not connected */
    Errno[Errno["ENOTCONN"] = 107] = "ENOTCONN";
    /** Cannot send after transport endpoint shutdown */
    Errno[Errno["ESHUTDOWN"] = 108] = "ESHUTDOWN";
    /** Too many references: cannot splice */
    Errno[Errno["ETOOMANYREFS"] = 109] = "ETOOMANYREFS";
    /** Connection timed out */
    Errno[Errno["ETIMEDOUT"] = 110] = "ETIMEDOUT";
    /** Connection refused */
    Errno[Errno["ECONNREFUSED"] = 111] = "ECONNREFUSED";
    /** Host is down */
    Errno[Errno["EHOSTDOWN"] = 112] = "EHOSTDOWN";
    /** No route to host */
    Errno[Errno["EHOSTUNREACH"] = 113] = "EHOSTUNREACH";
    /** Operation already in progress */
    Errno[Errno["EALREADY"] = 114] = "EALREADY";
    /** Operation now in progress */
    Errno[Errno["EINPROGRESS"] = 115] = "EINPROGRESS";
    /** Stale file handle */
    Errno[Errno["ESTALE"] = 116] = "ESTALE";
    /** Structure needs cleaning */
    Errno[Errno["EEUCLEAN"] = 117] = "EEUCLEAN";
    /** Not a XENIX named type file */
    Errno[Errno["ENOTNAM"] = 118] = "ENOTNAM";
    /** No XENIX semaphores available */
    Errno[Errno["ENAVAIL"] = 119] = "ENAVAIL";
    /** Is a named type file */
    Errno[Errno["EISNAM"] = 120] = "EISNAM";
    /** Remote I/O error */
    Errno[Errno["EREMOTEIO"] = 121] = "EREMOTEIO";
    /** Disk quota exceeded */
    Errno[Errno["EDQUOT"] = 122] = "EDQUOT";
    /** No medium found */
    Errno[Errno["ENOMEDIUM"] = 123] = "ENOMEDIUM";
    /** Wrong medium type */
    Errno[Errno["EMEDIUMTYPE"] = 124] = "EMEDIUMTYPE";
    /** Operation canceled */
    Errno[Errno["ECANCELED"] = 125] = "ECANCELED";
    /** Required key not available */
    Errno[Errno["ENOKEY"] = 126] = "ENOKEY";
    /** Key has expired */
    Errno[Errno["EKEYEXPIRED"] = 127] = "EKEYEXPIRED";
    /** Key has been revoked */
    Errno[Errno["EKEYREVOKED"] = 128] = "EKEYREVOKED";
    /** Key was rejected by service */
    Errno[Errno["EKEYREJECTED"] = 129] = "EKEYREJECTED";
    /** Owner died */
    Errno[Errno["EOWNERDEAD"] = 130] = "EOWNERDEAD";
    /** State not recoverable */
    Errno[Errno["ENOTRECOVERABLE"] = 131] = "ENOTRECOVERABLE";
    /** Operation not possible due to RF-kill */
    Errno[Errno["ERFKILL"] = 132] = "ERFKILL";
    /** Memory page has hardware error */
    Errno[Errno["EHWPOISON"] = 133] = "EHWPOISON";
})(Errno || (Errno = {}));
/**
 * Strings associated with each error code.
 * @internal
 */
const errnoMessages = {
    [Errno.EPERM]: 'Operation not permitted',
    [Errno.ENOENT]: 'No such file or directory',
    [Errno.ESRCH]: 'No such process',
    [Errno.EINTR]: 'Interrupted system call',
    [Errno.EIO]: 'Input/output error',
    [Errno.ENXIO]: 'No such device or address',
    [Errno.E2BIG]: 'Argument list too long',
    [Errno.ENOEXEC]: 'Exec format error',
    [Errno.EBADF]: 'Bad file descriptor',
    [Errno.ECHILD]: 'No child processes',
    [Errno.EAGAIN]: 'Resource temporarily unavailable',
    [Errno.ENOMEM]: 'Out of memory',
    [Errno.EACCES]: 'Permission denied',
    [Errno.EFAULT]: 'Bad address',
    [Errno.ENOTBLK]: 'Block device required',
    [Errno.EBUSY]: 'Resource busy or locked',
    [Errno.EEXIST]: 'File exists',
    [Errno.EXDEV]: 'Invalid cross-device link',
    [Errno.ENODEV]: 'No such device',
    [Errno.ENOTDIR]: 'File is not a directory',
    [Errno.EISDIR]: 'File is a directory',
    [Errno.EINVAL]: 'Invalid argument',
    [Errno.ENFILE]: 'Too many open files in system',
    [Errno.EMFILE]: 'Too many open files',
    [Errno.ETXTBSY]: 'Text file busy',
    [Errno.EFBIG]: 'File is too big',
    [Errno.ENOSPC]: 'No space left on disk',
    [Errno.ESPIPE]: 'Illegal seek',
    [Errno.EROFS]: 'Cannot modify a read-only file system',
    [Errno.EMLINK]: 'Too many links',
    [Errno.EPIPE]: 'Broken pipe',
    [Errno.EDOM]: 'Numerical argument out of domain',
    [Errno.ERANGE]: 'Numerical result out of range',
    [Errno.EDEADLK]: 'Resource deadlock would occur',
    [Errno.ENAMETOOLONG]: 'File name too long',
    [Errno.ENOLCK]: 'No locks available',
    [Errno.ENOSYS]: 'Function not implemented',
    [Errno.ENOTEMPTY]: 'Directory is not empty',
    [Errno.ELOOP]: 'Too many levels of symbolic links',
    [Errno.ENOMSG]: 'No message of desired type',
    [Errno.EIDRM]: 'Identifier removed',
    [Errno.ECHRNG]: 'Channel number out of range',
    [Errno.EL2NSYNC]: 'Level 2 not synchronized',
    [Errno.EL3HLT]: 'Level 3 halted',
    [Errno.EL3RST]: 'Level 3 reset',
    [Errno.ENRNG]: 'Link number out of range',
    [Errno.EUNATCH]: 'Protocol driver not attached',
    [Errno.ECSI]: 'No CSI structure available',
    [Errno.EL2HLT]: 'Level 2 halted',
    [Errno.EBADE]: 'Invalid exchange',
    [Errno.EBADR]: 'Invalid request descriptor',
    [Errno.EXFULL]: 'Exchange full',
    [Errno.ENOANO]: 'No anode',
    [Errno.EBADRQC]: 'Invalid request code',
    [Errno.EBADSLT]: 'Invalid slot',
    [Errno.EBFONT]: 'Bad font file format',
    [Errno.ENOSTR]: 'Device not a stream',
    [Errno.ENODATA]: 'No data available',
    [Errno.ETIME]: 'Timer expired',
    [Errno.ENOSR]: 'Out of streams resources',
    [Errno.ENONET]: 'Machine is not on the network',
    [Errno.ENOPKG]: 'Package not installed',
    [Errno.EREMOTE]: 'Object is remote',
    [Errno.ENOLINK]: 'Link has been severed',
    [Errno.EADV]: 'Advertise error',
    [Errno.ESRMNT]: 'Srmount error',
    [Errno.ECOMM]: 'Communication error on send',
    [Errno.EPROTO]: 'Protocol error',
    [Errno.EMULTIHOP]: 'Multihop attempted',
    [Errno.EDOTDOT]: 'RFS specific error',
    [Errno.EBADMSG]: 'Bad message',
    [Errno.EOVERFLOW]: 'Value too large for defined data type',
    [Errno.ENOTUNIQ]: 'Name not unique on network',
    [Errno.EBADFD]: 'File descriptor in bad state',
    [Errno.EREMCHG]: 'Remote address changed',
    [Errno.ELIBACC]: 'Can not access a needed shared library',
    [Errno.ELIBBAD]: 'Accessing a corrupted shared library',
    [Errno.ELIBSCN]: '.lib section in a.out corrupted',
    [Errno.ELIBMAX]: 'Attempting to link in too many shared libraries',
    [Errno.ELIBEXEC]: 'Cannot exec a shared library directly',
    [Errno.EILSEQ]: 'Invalid or incomplete multibyte or wide character',
    [Errno.ERESTART]: 'Interrupted system call should be restarted',
    [Errno.ESTRPIPE]: 'Streams pipe error',
    [Errno.EUSERS]: 'Too many users',
    [Errno.ENOTSOCK]: 'Socket operation on non-socket',
    [Errno.EDESTADDRREQ]: 'Destination address required',
    [Errno.EMSGSIZE]: 'Message too long',
    [Errno.EPROTOTYPE]: 'Protocol wrong type for socket',
    [Errno.ENOPROTOOPT]: 'Protocol not available',
    [Errno.EPROTONOSUPPORT]: 'Protocol not supported',
    [Errno.ESOCKTNOSUPPORT]: 'Socket type not supported',
    [Errno.ENOTSUP]: 'Operation is not supported',
    [Errno.EPFNOSUPPORT]: 'Protocol family not supported',
    [Errno.EAFNOSUPPORT]: 'Address family not supported by protocol',
    [Errno.EADDRINUSE]: 'Address already in use',
    [Errno.EADDRNOTAVAIL]: 'Cannot assign requested address',
    [Errno.ENETDOWN]: 'Network is down',
    [Errno.ENETUNREACH]: 'Network is unreachable',
    [Errno.ENETRESET]: 'Network dropped connection on reset',
    [Errno.ECONNABORTED]: 'Software caused connection abort',
    [Errno.ECONNRESET]: 'Connection reset by peer',
    [Errno.ENOBUFS]: 'No buffer space available',
    [Errno.EISCONN]: 'Transport endpoint is already connected',
    [Errno.ENOTCONN]: 'Transport endpoint is not connected',
    [Errno.ESHUTDOWN]: 'Cannot send after transport endpoint shutdown',
    [Errno.ETOOMANYREFS]: 'Too many references: cannot splice',
    [Errno.ETIMEDOUT]: 'Connection timed out',
    [Errno.ECONNREFUSED]: 'Connection refused',
    [Errno.EHOSTDOWN]: 'Host is down',
    [Errno.EHOSTUNREACH]: 'No route to host',
    [Errno.EALREADY]: 'Operation already in progress',
    [Errno.EINPROGRESS]: 'Operation now in progress',
    [Errno.ESTALE]: 'Stale file handle',
    [Errno.EEUCLEAN]: 'Structure needs cleaning',
    [Errno.ENOTNAM]: 'Not a XENIX named type file',
    [Errno.ENAVAIL]: 'No XENIX semaphores available',
    [Errno.EISNAM]: 'Is a named type file',
    [Errno.EREMOTEIO]: 'Remote I/O error',
    [Errno.EDQUOT]: 'Disk quota exceeded',
    [Errno.ENOMEDIUM]: 'No medium found',
    [Errno.EMEDIUMTYPE]: 'Wrong medium type',
    [Errno.ECANCELED]: 'Operation canceled',
    [Errno.ENOKEY]: 'Required key not available',
    [Errno.EKEYEXPIRED]: 'Key has expired',
    [Errno.EKEYREVOKED]: 'Key has been revoked',
    [Errno.EKEYREJECTED]: 'Key was rejected by service',
    [Errno.EOWNERDEAD]: 'Owner died',
    [Errno.ENOTRECOVERABLE]: 'State not recoverable',
    [Errno.ERFKILL]: 'Operation not possible due to RF-kill',
    [Errno.EHWPOISON]: 'Memory page has hardware error',
};
export function strerror(errno) {
    const _errno = typeof errno == 'string' ? Errno[errno] : errno;
    return (_errno in errnoMessages ? errnoMessages[_errno] : '');
}
/**
 * Set the message of an exception to the UV-style message.
 */
export function setUVMessage(ex) {
    let message = `${ex.code}: ${errnoMessages[ex.errno]}, ${ex.syscall}`;
    if (ex.path)
        message += ` '${ex.path}'`;
    if (ex.dest)
        message += ` -> '${ex.dest}'`;
    if (ex.message && !ex.message.startsWith(errnoMessages[ex.errno]))
        message += ` (${ex.message})`;
    ex.message = message;
    return ex;
}
/**
 * An error with additional information about what happened.
 *
 * @privateRemarks
 *
 * This is modeled after Node.js's `ErrnoException` and `UVException`.
 *
 * `Error.captureStackTrace` is used when available to hide irrelevant stack frames.
 * This is being standardized, however it is not available in Deno and behind a flag in Firefox.
 * See https://github.com/tc39/proposal-error-capturestacktrace for more details.
 */
export class Exception extends Error {
    errno;
    code;
    path;
    dest;
    syscall;
    constructor(errno, message, ctx = {}) {
        const code = Errno[errno];
        super(message || '');
        this.errno = errno;
        this.code = code;
        Object.assign(this, omit(ctx, 'message'));
        if (!message)
            setUVMessage(this);
        Error.captureStackTrace?.(this, this.constructor);
    }
    toString() {
        return this.message;
    }
    toJSON() {
        const json = {
            errno: this.errno,
            code: this.code,
            stack: this.stack,
            message: this.message,
        };
        if (this.path)
            json.path = this.path;
        if (this.dest)
            json.dest = this.dest;
        if (this.syscall)
            json.syscall = this.syscall;
        return json;
    }
    static fromJSON(json) {
        const err = json.syscall ? new Exception(json.errno, false, json) : new Exception(json.errno, json.message);
        err.stack = json.stack;
        return err;
    }
}
export function UV(code, context, path, dest) {
    if (typeof context === 'string')
        context = { syscall: context, path, dest };
    const err = new Exception(Errno[code], false, context ?? {});
    Error.captureStackTrace?.(err, UV);
    return err;
}
/**
 * Shortcut to easily create an `Exception` with a specific error code.
 */
export function withErrno(code, message) {
    const err = new Exception(Errno[code], message ?? errnoMessages[Errno[code]]);
    Error.captureStackTrace?.(err, withErrno);
    return err;
}
export function rethrow(extra, path, dest) {
    const ctx = typeof extra === 'string' ? { syscall: extra } : extra;
    if (path)
        ctx.path = path;
    if (dest)
        ctx.dest = dest;
    return function (e) {
        Object.assign(e, ctx);
        setUVMessage(e);
        throw e;
    };
}
